/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmTrxPendingStatusInfo = {
    TRXPS: EvmTrxPendingStatusInfo.TRXPS;
};

export namespace EvmTrxPendingStatusInfo {

    export enum TRXPS {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
    }


}

